var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "price-block" }, [
    _vm._v("\n    " + _vm._s(_vm.label)),
    _c("br"),
    _vm._v(" "),
    _vm.addPlus ? _c("span", [_vm._v("\n        + ")]) : _vm._e(),
    _c("span", { class: { blue: _vm.variant === "blue" } }, [
      _vm._v(
        "\n        " + _vm._s(_vm._f("numeral")(_vm.value, "$0,0")) + "\n    "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }